<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

// document.addEventListener('DOMContentLoaded', function () {
//   const bonusVariantId = "47045047648508";
//   const restrictedVariantIds = new Set([
//     47035834990844,
//     47035835023612,
//     39373029998782,
//     40363010687166,
//     39373042155710,
//   ]);

//   document.body.addEventListener('click', function (event) {
//     if (event.target.matches('[data-btn-addtocart]') || event.target.closest('[data-btn-addtocart]')) {
//       setTimeout(() => {
//         fetch('/cart.js')
//           .then(response => response.json())
//           .then(cart => {
//             let bonusInCart = false;
//             let hasRestrictedItem = false;

//             cart.items.forEach(item => {
//               if (item.variant_id == bonusVariantId) {
//                 bonusInCart = true;
//               }
//               if (restrictedVariantIds.has(item.variant_id)) {
//                 hasRestrictedItem = true;
//               }
//             });

//             if (hasRestrictedItem) {
//               // Remove bonus if restricted items exist
//               fetch('/cart/change.js', {
//                 method: 'POST',
//                 headers: {
//                   'Content-Type': 'application/json',
//                   'Accept': 'application/json'
//                 },
//                 body: JSON.stringify({
//                   id: bonusVariantId,
//                   quantity: 0
//                 })
//               }).then(() => {
//                 console.log('Bonus product removed due to restricted product in cart.');
//               });
//             } else if (!hasRestrictedItem && !bonusInCart) {
//               // Add bonus if no restricted items and bonus not already added
//               fetch('/cart/add.js', {
//                 method: 'POST',
//                 headers: {
//                   'Content-Type': 'application/json',
//                   'Accept': 'application/json'
//                 },
//                 body: JSON.stringify({
//                   id: bonusVariantId,
//                   quantity: 1
//                 })
//               })
//               .then(res => res.json())
//               .then(data => {
//                 console.log('Bonus product added:', data);
//               })
//               .catch(err => console.error('Error adding bonus product:', err));
//             }
//           });
//       }, 850);
//     }
//   });
// });


  function setupMobileScroll() {
    const row = document.querySelector('.container-1470 .halo-row.column-4');
    if (!row) return;

    // Save original HTML only once
    if (!row.dataset.originalHtml) {
      row.dataset.originalHtml = row.innerHTML;
    }

    const isMobile = window.innerWidth < 750;

    // If not mobile, restore original layout
    if (!isMobile) {
      row.innerHTML = row.dataset.originalHtml;
      row.style.display = '';
      row.style.overflowX = '';
      row.style.flexWrap = '';
      return;
    }

    // Prevent duplicate wrapping
    if (row.querySelector('.halo-scroll-page')) return;

    // Extract original items
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = row.dataset.originalHtml;
    const items = Array.from(tempContainer.querySelectorAll('.halo-item'));

    // Clear and style row
    row.innerHTML = '';
    row.style.display = 'flex';
    row.style.overflowX = 'auto';
    row.style.flexWrap = 'nowrap';

    for (let i = 0; i < items.length; i += 4) {
      const group = document.createElement('div');
      group.classList.add('halo-scroll-page');

      items.slice(i, i + 4).forEach(item => group.appendChild(item));
      row.appendChild(group);
    }
  }

  // Run on load
  window.addEventListener('DOMContentLoaded', setupMobileScroll);

  // Re-run on resize
  window.addEventListener('resize', () => {
    clearTimeout(window._haloResizeTimeout);
    window._haloResizeTimeout = setTimeout(setupMobileScroll, 200);
  });
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->



document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById("tagFilter");
   if (!slider) return;
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.classList.add("active");
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
    slider.classList.remove("active");
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
    slider.classList.remove("active");
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2; // speed multiplier
    slider.scrollLeft = scrollLeft - walk;
  });

  // ✅ Also works on touch screens
  slider.addEventListener("touchstart", (e) => {
    startX = e.touches[0].pageX;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("touchmove", (e) => {
    const x = e.touches[0].pageX;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });
});


